import { Button, Modal } from '@unimed-fesp/components';
import React from 'react';

import { RiErrorWarningLine } from 'react-icons/ri';
import {
  ModalContent,
  ModalContentWrapper,
  ModalFooter,
  ModalHeader,
} from '../../molecules/Modal';

import theme from '../../../styles/theme';

import { Container, ContentText, TextSucesso } from './styles';

function ModalCancelAction({
  isOpen,
  onClick,
  onClickOk,
  text,
  textHeader,
  isLoading,
}) {
  return (
    <Modal
      isOpen={isOpen}
      onClick={!isLoading && onClick}
      height={370}
      width="460"
      footer={
        <Footer onClick={onClick} onClickOk={onClickOk} isLoading={isLoading} />
      }
    >
      <ModalContent>
        <Container>
          <RiErrorWarningLine color={theme.yellow} size="100" />
          <TextSucesso text={textHeader} />
          <ContentText>{text}</ContentText>
        </Container>
      </ModalContent>
    </Modal>
  );
}

const Footer = ({ onClick, isLoading, onClickOk }) => (
  <ModalFooter padding="0">
    <Button
      tipo="secondary"
      onClick={onClick}
      marginRight={14}
      type="button"
      justifyCenter
      alignCenter
      width={121}
      disabled={isLoading}
      font="16px unimed_slabregular"
    >
      cancelar
    </Button>
    <Button
      tipo="primary"
      onClick={onClickOk}
      marginLeft={14}
      type="button"
      justifyCenter
      alignCenter
      width={121}
      disabled={isLoading}
      font="16px unimed_slabregular"
    >
      sim
    </Button>
  </ModalFooter>
);

export default ModalCancelAction;
